const Tools = {
  SOLID_LINE: 0,
  MARCHING_ANTS: 1
}

export default function createContextWrapper (canvas) {
  const ctx = canvas.getContext("2d")
  const state = {
    openPath: false,
    tool: Tools.SOLID_LINE,
    fat: false,
    coord: [100, 100],
    color: "white"
  }

  function gradient () {
    state.openPath = false
    // setStrokeThickness(1)
    setStrokeColor("#ffffff")

    const g = ctx.createLinearGradient(0, 0, 0, canvas.height)
    g.addColorStop(0, "#542233")
    g.addColorStop(1, "#321031")
    ctx.fillStyle = g

    ctx.fillRect(0, 0, 1920, 1080)
  }

  function clear () {
    ctx.clearRect(0, 0, 1920, 1080)
  }

  function lineTo (segment) {
    switch (state.tool) {
      case Tools.MARCHING_ANTS:
        beginPath()
        ctx.lineTo(segment[0], segment[1])
        break

      case Tools.SOLID_LINE:
        beginPath()
        ctx.moveTo(state.coord[0], state.coord[1])
        ctx.lineWidth = segment[2] * 5
        ctx.lineTo(segment[0], segment[1])
        stroke()
        break

      default:
        console.warn("unknown tool", state.tool)
    }

    state.coord = segment
  }

  function moveTo (segment) {
    // beginPath()
    // ctx.moveTo(segment[0], segment[1])
    // state.last = segment
    // stroke()

    switch (state.tool) {
      case Tools.MARCHING_ANTS:
        stroke()
        ctx.moveTo(segment[0], segment[1])
        break

      case Tools.SOLID_LINE:
        break

      default:
        console.warn("unknown tool", state.tool)
    }

    state.coord = segment
  }

  function setMarchingAnts () {
    // stroke()
    state.tool = Tools.MARCHING_ANTS
    ctx.strokeStyle = "white"
    ctx.lineWidth = 1
    ctx.setLineDash([8, 8])
  }

  function lineDashOffset (offset) {
    ctx.lineDashOffset = offset << 0
  }

  function beginPath () {
    if (!state.openPath) {
      state.openPath = true
      ctx.beginPath()
    }
  }

  function stroke () {
    if (state.openPath) {
      ctx.stroke()
      state.openPath = false
    }
  }

  function drawCursor () {
    const { coord } = state
    const rememberCoord = { ...coord }
    const rememberStroke = ctx.lineWidth
    const rememberStyle = ctx.strokeStyle
    const rememberTool = state.tool

    state.tool = Tools.SOLID_LINE

    ctx.lineWidth = 2

    moveTo([coord[0] - 20, coord[1]])
    lineTo([coord[0] + 20, coord[1]])
    moveTo([coord[0], coord[1] - 20])
    lineTo([coord[0], coord[1] + 20])

    ctx.lineWidth = rememberStroke
    ctx.strokeStyle = rememberStyle
    state.coord = rememberCoord
    state.tool = rememberTool
  }

  function setStrokeColor (color) {
    state.tool = Tools.SOLID_LINE
    stroke()
    ctx.setLineDash([])
    ctx.strokeStyle = color
    state.color = color
  }

  function fat (isFat) {
    // stroke()
    // ctx.lineWidth = isFat ? 50 : 1
    state.fat = isFat
  }

  return {
    clear,
    moveTo,
    lineTo,
    gradient,
    stroke,
    drawCursor,
    setStrokeColor,
    fat,
    setMarchingAnts,
    lineDashOffset
  }
}



// WEBPACK FOOTER //
// ./src/canvas/context.js